import React from 'react'
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';

const NomenclatureItem = ({ data }) => {
    const { t } = useTranslation();

    return <div className='container'>
        {
            data.map((item, index) => {
                const titleTranslated = item.titleCompose ? item.titleCompose : t(item.title);

                return (
                    <div className='c-content' key={index}>
                        <div className='icon'>{item.icon}</div>
                        <div className='title'>{capitalizeFirstLetter(titleTranslated)}</div>
                        {item?.description && <div className='description'>{item.description}</div>}
                    </div>
                )
            })
        }
    </div>
}

export default NomenclatureItem 